'use client'

import Reveal from '../Reveal'

const features = [
  {
    title: 'Segregated cold storage',
    body: 'Collateral is held in institutional-grade, multi-sig cold wallets — never rehypothecated or lent out.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    ),
  },
  {
    title: '$300M custody insurance',
    body: 'Assets under custody are protected against theft and physical loss by leading underwriters.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    ),
  },
  {
    title: 'Proof of reserves',
    body: 'Real-time, on-chain attestations let you verify that every loan is fully backed at all times.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-6h6v6m-3-14v2m0 14v2m9-9h-2M5 12H3m14.657-6.657l-1.414 1.414M7.757 16.243l-1.414 1.414m0-11.314l1.414 1.414m8.486 8.486l1.414 1.414" />
    ),
  },
  {
    title: 'SOC 2 Type II certified',
    body: 'Independently audited security controls, penetration-tested quarterly by third-party firms.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4" />
    ),
  },
]

export default function Security() {
  return (
    <section id="security" className="relative py-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="text-xs tracking-[0.3em] text-electric-400 uppercase mb-3">
            Built for trust
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl text-chrome leading-tight">
            Your keys are safe.
            <br />Your assets, insured.
          </h2>
          <p className="mt-5 text-steel-300 leading-relaxed max-w-lg">
            Crypto Credits is engineered from the ground up to protect the assets you
            pledge. We combine bank-grade custody, transparent on-chain reserves and
            continuous auditing so you can borrow with total peace of mind.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {['Non-custodial vaults', 'On-chain reserves', 'GDPR compliant', '24/7 monitoring'].map(
              (t) => (
                <span
                  key={t}
                  className="px-4 py-2 rounded-full glass text-sm text-steel-200"
                >
                  {t}
                </span>
              )
            )}
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-5">
          {features.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08}>
              <div className="glass glass-hover rounded-2xl p-6 h-full">
                <div className="w-11 h-11 rounded-xl bg-electric-500/10 ring-1 ring-electric-500/30 flex items-center justify-center mb-4 shadow-glow-sm">
                  <svg className="w-5.5 h-5.5 text-electric-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
                    {f.icon}
                  </svg>
                </div>
                <h3 className="font-semibold text-white mb-1.5">{f.title}</h3>
                <p className="text-sm text-steel-300 leading-relaxed">{f.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
